import { EndpointQueryParameters } from '../../../types/strapi/strapi'

/**
 * Свежий статус согласования для меню действий отгрузки.
 * Куратор решает в своём браузере, строка списка у менеджера об этом не знает.
 */
export const shipmentApprovalQueryParams: EndpointQueryParameters = {
    fields: ['documentId', 'approved'],
    populate: {
        tasks: {
            fields: ['documentId', 'type', 'taskStatus', 'createdAt'],
        },
    },
}
